import { tokens as uiTokens } from '@fme-nova/tokens'

import { UIPalette } from './uiPalete.type'

const error = {
  main: uiTokens.uiContent.errorIntense,
  dark: '#90112F',
  light: '#FEF3EA',
  contrast: '#FFFFFF',
  outlinedBorder: '#B31B324D',
}

const warning = {
  main: '#CD6B00',
  dark: '#AC5200',
  light: '#FEF9E5',
  contrast: '#FFFFFF',
  outlinedBorder: '#CD6B004D',
}

const info = {
  main: uiTokens.uiContent.neutral,
  dark: '#002478',
  light: '#E5F8FE',
  contrast: '#FFFFFF',
  outlinedBorder: '#0149B54D',
}

const none = {
  main: '#00000099',
  dark: '#000000',
  light: '#b3b3b3',
  contrast: '#FFFFFF',
  outlinedBorder: '#000000',
}

export const NOVA_PALETTE: UIPalette = {
  blueGrey100: '#DCE2EF',
  blueGrey700: '#4E5769',
  blueGrey800: '#343E52',
  blueGrey900: '#1C273E',
  blue700: '#0033A0',
  blue900: '#00185C',
  blue100: '#CCE5FF',

  grey50: uiTokens.uiSurface.background,
  border: '#0000001F',

  divider: uiTokens.uiStroke.neutral,

  button: {
    main: uiTokens.uiControl.contained.enabled,
    dark: '#002375',
  },

  primary: {
    main: uiTokens.uiContent.accent,
    dark: '#0644B8',
    light: '#3E84ED',
    contrast: '#FFFFFF',
    hover: '#0D58D90A',
    selected: '#0D58D914',
    focus: '#0D58D91F',
    focusVisible: '#0D58D933',
    outlinedBorder: '#0D58D94D',
  },

  text: {
    primary: '#000000', // should be #000000CC
    secondary: '#00000099',
    disabled: uiTokens.uiContent.disabled,
  },

  error,
  warning,
  info,

  success: {
    main: uiTokens.uiContent.success,
    dark: '#064C28',
    light: '#F1FFEB',
    contrast: '#FFFFFF',
    outlinedBorder: '#11732E4D',
  },

  action: {
    active: uiTokens.uiContent.accent,
    hover: uiTokens.uiSurface.hover,
    selected: uiTokens.uiSurface.pressedOrSelected,
    diasbeldBackround: uiTokens.color.opacity.blue900A16,
    focus: '#0000001F',
    disabled: uiTokens.uiControl.contained.disabled,
    readOnly: '#EEEEEE',
  },

  white: {
    main: '#FFFFFF',
    selected: '#FFFFFF14',
    outlinedBorder: '#FFFFFF4D',
  },

  grey: {
    main: '#0D58D9',
    dark: '#0644B8',
    light: '#3E84ED',
    contrast: '#FFFFFF',
    hover: '#0D58D90A',
    selected: '#0D58D914',
    focus: '#0D58D91F',
    focusVisible: '#0D58D933',
    outlinedBorder: '#0D58D94D',
    resizer: '#989898',
    cardBorder: '#C2C3CC',
    label: '#575966',
  },

  validation: {
    error,
    warning,
    info,
    none,
  },

  components: {
    form: {
      background: uiTokens.uiSurface.background,

      group: {
        background: uiTokens.uiSurface['wm-static'],
      },
    },
    input: {
      readonlyBorder: '#EEEEEE',
      enabledBorder: uiTokens.uiStroke.neutral,
      hoverBorder: uiTokens.uiStroke.accent,
      background: uiTokens.uiControl.outlined.enabled,
    },
    modal: {
      background: uiTokens.uiSurface.interactive,
    },
    tooltip: {
      fill: '#616161E5',
    },
    navigation: {
      main: '#6A768F',
      dark: '#39496A',
    },
    tab: {
      content: {
        background: uiTokens.uiSurface.background,
      },
    },
    table: {
      background: uiTokens.uiSurface.interactive,
    },
    viewContent: {
      background: uiTokens.uiSurface.background,
    },
  },

  logs: {
    delete: '#FFD1D8',
    deleteLight: '#FFEBEE',
    add: '#A9EEAA',
    addLight: '#DFFAE4',
    change: '#CD6B00',
    changeLight: '#FEF9E5',
    empty: '#BCC5D5',
    emptyLight: '#F4F7FB',
  },
}
